var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.annotation[_vm.type])}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }